module.exports = __webpack_public_path__ + "img/partner_img12.1cfb9d25.png";